import i18n from "@/libs/i18n";

export default [
  {
    get header() {
      return i18n.t("surgery.ivf");
    },
    permission: "get-ivfExpanses",
    role: "IVF",
  },

  {
    get title() {
      return i18n.t("surgery.ivf-expenses");
    },
    route: "ivf-expenses",
    icon: "DollarSignIcon",
    permission: "get-ivfExpanses",
    role: "IVF",
  },
  {
    get title() {
      return i18n.t("surgery.ivf-income");
    },
    route: "ivf-income",
    icon: "DollarSignIcon",
    permission: "get-ivfIncome",
    role: "IVF",
  },
  {
    get title() {
      return i18n.t("operation.exchange-rate");
    },
    icon: "ShieldIcon",
    route: "exchange-rate",
    permission: "get-ivf-exchange-rate",
    role: "IVF",
  },
  {
    get title() {
      return i18n.t("common.ivf-balance");
    },
    route: "ivf-balance",
    icon: "DollarSignIcon",
    permission: "get-balance",
    role: "IVF",
  },
];
